import type {
  BasePromoBannerProps,
  PromoBannerVariant,
} from "@/components/PromoBanner/types";
import type { PromoBannerMonarchProps } from "@/monarch/types/PromoBanner";

type ResolveVariantOptions = {
  sideRail?: boolean;
};

export function resolveVariant(
  data: PromoBannerMonarchProps,
  fallbackVariant: PromoBannerVariant,
  options: ResolveVariantOptions = {},
): PromoBannerVariant {
  if (data.slimV2) {
    return options.sideRail ? "slimV2SideRail" : "slimV2";
  }

  // Monarch's "complete" payload is the original Slim banner in PDP.
  if (data.complete) {
    return "slim";
  }

  if (data.compactV2 || data.compact) {
    return "compactPDP";
  }

  return fallbackVariant;
}

export function resolveCompleteProps(
  data: PromoBannerMonarchProps,
  finalVariant: PromoBannerVariant,
): BasePromoBannerProps {
  const { slimV2, complete, compactV2 } = data;
  const completeLikeData = slimV2 ?? complete;

  if (compactV2 && finalVariant === "compactPDP") {
    const { iconType, cta, ...props } = compactV2;

    if (cta) {
      const { htmlId, ...ctaProps } = cta;
      return {
        ...props,
        cta: { ...ctaProps, html_id: htmlId },
        iconType,
      };
    }

    return { ...props, iconType };
  }

  if (!completeLikeData) {
    return {};
  }

  const {
    backgroundImage,
    backgroundType,
    title,
    discountCode,
    description,
    endDatePrefix,
    endDate,
    image,
    cta,
    learnMoreLink,
    tooltip,
  } = completeLikeData;

  const isSlimV2Like =
    finalVariant === "slimV2" || finalVariant === "slimV2SideRail";

  return {
    backgroundImage,
    backgroundType,
    title,
    discountCode,
    ...(!isSlimV2Like && complete ? { discount: complete.discount } : {}),
    description,
    endDatePrefix,
    endDate,
    image,
    cta,
    learnMoreLink,
    tooltip,
  };
}
